import React from "react";
import PropTypes from "prop-types";
import Link from "../Global/Link";

const CardNews = (props) => {
  const { text, link, icon, imageSrc, imageAlt, imageStyle } = props;

  if (!link) return null;

  return (
    <div
      className={`d-flex flex-column overflow-hidden h-100 position-relative text-center`}
    >
      <Link
        to={link}
        icon={icon && icon}
        className="py-4 brand-background-dark-gradiant brand-font brand-text-white brand-link-white brand-cursor fs-4 mb-0"
      >
        <span className="me-2">{text}</span>
        <img src={imageSrc} alt={imageAlt} style={imageStyle} />
      </Link>
    </div>
  );
};

export default CardNews;

CardNews.propTypes = {
  text: PropTypes.string,
  link: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  icon: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  imageStyle: PropTypes.object,
};

CardNews.defaultProps = {
  text: null,
  link: null,
  icon: null,
  imageSrc: null,
  imageAlt: null,
  imageStyle: null,
};
